<template>
  <div>
    <v-dialog v-model="dialog" max-width="500" scrollable>
      <v-card>
        <v-card-title>
          <template v-if="event == 'create'">
            <v-icon left>mdi-plus-box-multiple</v-icon>{{ $t('product.add_product_list') }}
          </template>
          <template v-if="event == 'edit'">
            <v-icon left>mdi-pencil</v-icon>{{ $t('product.edit_product_list') }}
          </template>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-5">
          <span>{{ $t('product.product_code') }}</span>
          <v-text-field :label="$t('product.product_code')" :placeholder="$t('product.product_code')" v-model="form.erpId" solo flat
            background-color="grey lighten-4"></v-text-field>
          <span>{{ $t('product.product_name') }}</span>
          <v-text-field :label="$t('product.product_name')" :placeholder="$t('product.product_name')" v-model="form.name" solo flat
            background-color="grey lighten-4"></v-text-field>
          <span>{{ $t('product.product_category') }}</span>
          <v-autocomplete v-model="form.productCategoryId" :items="categories" item-text="lable" item-value="objectId"
            solo flat background-color="grey lighten-4" append-icon="mdi-plus-thick" :label="$t('product.product_category')" @click:append="
              sendCategoryEvent = 'create';
            addProductCategory = true;
            ">
            <template v-slot:item="{ item }">
              {{ item.lable }}
              <v-btn small elevation="0" color="warning" icon class="ml-2" @click="getCategoryObj(item)"><v-icon
                  size="20">mdi-pencil</v-icon></v-btn>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mx-3">
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="dialog = false">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn color="success" elevation="0" @click="event == 'create' ? createProduct() : updateProduct()"
            :loading="isLoading" :disabled="!form.name || !form.productCategoryId || isLoading">
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <FormProductCategory v-model="addProductCategory" :event="sendCategoryEvent" :obj="selectCategoryObj">
    </FormProductCategory>
  </div>
</template>

<script>
import FormProductCategory from "./FormProductCategory";
import { mapGetters } from "vuex";
export default {
  components: { FormProductCategory },
  name: "AddProduct",
  computed: {
    ...mapGetters({
      categories: "productCategory/getCategories",
    }),
    dialog: {
      get() {
        if (this.value) {
          this.init()
          if (this.event == "edit") {
            const newObj = Object.assign({}, this.obj);
            this.form = newObj;
            this.form.productCategoryId = newObj.productCategory.objectId
          } else {
            this.form = {
              name: "",
              erpId: "",
              name_en: "",
              productCategoryId: "",
            };
          }
        }
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  created() { },
  mounted() { },
  data() {
    return {
      form: {
        name: "",
        erpId: "",
        name_en: "",
        productCategory: "",
      },
      addProductCategory: false,
      isLoading: false,
      sendCategoryEvent: "create",
      selectCategoryObj: {},
    };
  },
  props: {
    value: Boolean,
    obj: Object,
    event: String,
  },
  methods: {
    debug() { },
    async init() {
      await this.$store.dispatch("productCategory/getProductCategories");
    },
    getCategoryObj(obj) {
      this.sendCategoryEvent = "edit";
      this.selectCategoryObj = obj;
      this.addProductCategory = true;
    },
    async createProduct() {
      this.isLoading = true;
      const create = await this.$store.dispatch("product/createProduct", {
        name: this.form.name,
        name_en: this.form.name_en,
        erpId: this.form.erpId,
        productCategoryId: this.form.productCategoryId,
      });
      this.form = {
        name: "",
        productCategoryId: "",
      };
      this.$emit("onLoad");
      this.dialog = false;
      this.isLoading = false;
    },
    async updateProduct() {
      try {
        this.isLoading = true;
        const updateProduct = await this.$store.dispatch(
          "product/updateProduct",
          {
            id: this.form.objectId,
            name: this.form.name,
            name_en: this.form.name_en,
            erpId: this.form.erpId,
            productCategoryId: this.form.productCategoryId,
          }
        );
        this.$emit("onUpdated");
        this.form = {
          name: "",
          productCategoryId: "",
        };
        this.isLoading = false;
        this.dialog = false;
      } catch (err) {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
